import { storage } from './storage';

export type Theme = 'light' | 'dark';

export function getTheme(): Theme {
  return storage.get('ui.theme') === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  storage.set('ui.theme', theme);
}
